import { Box, Button, Grid, Group, Modal, NumberInput, Select, Text, Textarea, TextInput } from '@mantine/core';
import { IconDeviceFloppy } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';

const LoyaltyCouponModal = ({ loyaltyCoupon: passedLoyaltyCoupon, onClose, onSave }) => {
  const { accountId, domainId } = useParams();
  const currentDomain = useSelector((state) => state.domain.domain);
  const fetch = useFetch();

  const [loyaltyCoupon, setLoyaltyCoupon] = useState(passedLoyaltyCoupon);
  const [coupons, setCoupons] = useState();
  const [laodError, setLoadError] = useState();
  const [userError, setUserError] = useState();

  useEffect(() => {
    setLoyaltyCoupon(passedLoyaltyCoupon);
  }, [passedLoyaltyCoupon]);

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/coupons`)
      .then(({ coupons }) => {
        setCoupons(coupons);
      })
      .catch(setLoadError);
  }, [accountId, domainId, fetch]);

  if (loyaltyCoupon === undefined) {
    return '';
  }

  if (laodError) {
    return <ErrorMessage message={laodError.message} />;
  }

  const saveLoyaltyCoupon = (e) => {
    e.preventDefault();
    setUserError(undefined);

    const fetchFunc = loyaltyCoupon?.id
      ? fetch(
          `/api/admin/accounts/${currentDomain.accountId}/domains/${currentDomain.id}/loyalty/coupons/${loyaltyCoupon.id}`,
          {
            method: 'PUT',
            body: JSON.stringify({ loyaltyCoupon }),
          }
        )
      : fetch(`/api/admin/accounts/${currentDomain.accountId}/domains/${currentDomain.id}/loyalty/coupons`, {
          method: 'POST',
          body: JSON.stringify({ loyaltyCoupon }),
        });

    fetchFunc
      .then(({ loyaltyCoupon }) => {
        onSave(loyaltyCoupon);
        onClose();
      })
      .catch(setUserError);
  };

  return (
    <>
      <Modal
        opened={!!passedLoyaltyCoupon}
        onClose={onClose}
        title={`${loyaltyCoupon?.id ? 'Edit' : 'Add'} Loyalty Redeem Rule`}
      >
        <Box component="form" ta="left" onSubmit={saveLoyaltyCoupon}>
          <Grid align="center" mb="sm">
            <Grid.Col span={{ base: 12, sm: 3 }}>
              <Text fw={500}>Coupon*</Text>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 9 }}>
              <Select
                data={coupons?.map((e) => ({ label: e.name, value: e.id.toString() })) || []}
                onChange={(value) => setLoyaltyCoupon({ ...loyaltyCoupon, couponId: value })}
                error={!loyaltyCoupon.couponId}
                value={loyaltyCoupon.couponId?.toString()}
              />
            </Grid.Col>
          </Grid>

          <Grid align="center" mb="sm">
            <Grid.Col span={{ base: 12, sm: 3 }}>
              <Text fw={500}>Title*</Text>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 9 }}>
              <TextInput
                name="title"
                required
                value={loyaltyCoupon.title || ''}
                error={!loyaltyCoupon.title}
                onChange={(e) => setLoyaltyCoupon({ ...loyaltyCoupon, title: e.target.value })}
              />
            </Grid.Col>
          </Grid>

          <Grid align="center" mb="sm">
            <Grid.Col span={{ base: 12, sm: 3 }}>
              <Text fw={500}>Description*</Text>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 9 }}>
              <Textarea
                name="description"
                rows={3}
                required
                value={loyaltyCoupon.description || ''}
                error={!loyaltyCoupon.description}
                onChange={(e) => setLoyaltyCoupon({ ...loyaltyCoupon, description: e.target.value })}
              />
            </Grid.Col>
          </Grid>

          <Grid align="center" mb="sm">
            <Grid.Col span={{ base: 12, sm: 3 }}>
              <Text fw={500}>Point cost*</Text>
            </Grid.Col>
            <Grid.Col span={{ base: 12, sm: 9 }}>
              <NumberInput
                name="pointCost"
                required
                min={1}
                step={1}
                value={loyaltyCoupon.pointCost || 0}
                error={!loyaltyCoupon.pointCost}
                onChange={(value) => setLoyaltyCoupon({ ...loyaltyCoupon, pointCost: value })}
              />
            </Grid.Col>
          </Grid>

          <Group justify="flex-end" mt="md">
            <Button variant="default" onClick={onClose}>
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={
                !loyaltyCoupon?.pointCost ||
                !loyaltyCoupon?.couponId ||
                !loyaltyCoupon?.title ||
                !loyaltyCoupon?.description
              }
            >
              <IconDeviceFloppy size={16} /> Save
            </Button>
          </Group>
          {userError && <ErrorMessage message={userError.message} />}
        </Box>
      </Modal>
    </>
  );
};

export default LoyaltyCouponModal;
